import { Badge, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CongSetting, CongSettingMap, CongSettings } from "../../../types/scheduling/settings";
import { CheckBox, DDMnumbers } from "./settings";

const CleaningLabelWithWeekly = (props: {
  settings: CongSettings;
  setSettings: (set: CongSettings) => void;
  labelKey: CongSetting;
  weeklyKey: CongSetting;
  pill: number;
  hidden?: boolean;
}) => {
  const { t } = useTranslation();

  if (props.hidden) return null;

  return (
    <Form.Group as={Row} className="mt-1">
      <Form.Label column>
        {t(CongSettingMap[props.labelKey])}
        <Badge pill bg="secondary" className="ms-1">
          {props.pill}
        </Badge>
      </Form.Label>
      <Col>
        <div className="d-flex align-items-center gap-2">
          <Form.Control
            as="input"
            type="text"
            maxLength={64}
            value={props.settings[props.labelKey] as string}
            onChange={(e) => {
              props.setSettings({
                ...props.settings,
                [props.labelKey]: e.target.value,
              });
            }}
            className="flex-grow-1"
          />
          <div className="d-flex align-items-center gap-1 text-nowrap">
            <Form.Check
              type="switch"
              checked={props.settings[props.weeklyKey] as boolean}
              onChange={(e) => {
                props.setSettings({
                  ...props.settings,
                  [props.weeklyKey]: e.target.checked,
                });
              }}
              label={t(CongSettingMap[props.weeklyKey])}
              className="mb-0"
            />
          </div>
        </div>
      </Col>
    </Form.Group>
  );
};

export const SettingsCleaning = (props: { settings: CongSettings; setSettings: (set: CongSettings) => void }) => {
  return (
    <div>
      <DDMnumbers
        settingKey={CongSetting.NumberOfCleaningAssignments}
        settings={props.settings}
        setSettings={props.setSettings}
        options={8}
      />
      <CleaningLabelWithWeekly
        settings={props.settings}
        setSettings={props.setSettings}
        labelKey={CongSetting.CleaningLabel1}
        weeklyKey={CongSetting.CleaningWeekly1}
        pill={1}
        hidden={props.settings.number_of_cleaning_assignments < 1}
      />
      <CleaningLabelWithWeekly
        settings={props.settings}
        setSettings={props.setSettings}
        labelKey={CongSetting.CleaningLabel2}
        weeklyKey={CongSetting.CleaningWeekly2}
        pill={2}
        hidden={props.settings.number_of_cleaning_assignments < 2}
      />
      <CleaningLabelWithWeekly
        settings={props.settings}
        setSettings={props.setSettings}
        labelKey={CongSetting.CleaningLabel3}
        weeklyKey={CongSetting.CleaningWeekly3}
        pill={3}
        hidden={props.settings.number_of_cleaning_assignments < 3}
      />
      <CleaningLabelWithWeekly
        settings={props.settings}
        setSettings={props.setSettings}
        labelKey={CongSetting.CleaningLabel4}
        weeklyKey={CongSetting.CleaningWeekly4}
        pill={4}
        hidden={props.settings.number_of_cleaning_assignments < 4}
      />
      <CleaningLabelWithWeekly
        settings={props.settings}
        setSettings={props.setSettings}
        labelKey={CongSetting.CleaningLabel5}
        weeklyKey={CongSetting.CleaningWeekly5}
        pill={5}
        hidden={props.settings.number_of_cleaning_assignments < 5}
      />
      <CleaningLabelWithWeekly
        settings={props.settings}
        setSettings={props.setSettings}
        labelKey={CongSetting.CleaningLabel6}
        weeklyKey={CongSetting.CleaningWeekly6}
        pill={6}
        hidden={props.settings.number_of_cleaning_assignments < 6}
      />
      <CleaningLabelWithWeekly
        settings={props.settings}
        setSettings={props.setSettings}
        labelKey={CongSetting.CleaningLabel7}
        weeklyKey={CongSetting.CleaningWeekly7}
        pill={7}
        hidden={props.settings.number_of_cleaning_assignments < 7}
      />
      <CleaningLabelWithWeekly
        settings={props.settings}
        setSettings={props.setSettings}
        labelKey={CongSetting.CleaningLabel8}
        weeklyKey={CongSetting.CleaningWeekly8}
        pill={8}
        hidden={props.settings.number_of_cleaning_assignments < 8}
      />
      <CheckBox
        switchType
        settingKey={CongSetting.CleaningNotifyGroup}
        settings={props.settings}
        setSettings={props.setSettings}
      />
    </div>
  );
};
